import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  onCloseDialog: () => void
  onTransfer: () => void
  isDocumentListFiltered: boolean
  loading: boolean
}

const TransferAllDialog = ({
  loading,
  open,
  onCloseDialog,
  onTransfer,
  isDocumentListFiltered,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('documentView.transferAllDialog.transferAllDocuments')}
      open={open}
      onCancel={onCloseDialog}
      footer={[
        <Button key="cancel" onClick={onCloseDialog}>
          {t('labels.cancel')}
        </Button>,
        <Button
          key="transfer"
          type="primary"
          danger
          loading={loading}
          onClick={onTransfer}
        >
          {t('documentView.transferAllDialog.deletePerm')}
        </Button>,
      ]}
    >
      {isDocumentListFiltered
        ? t('documentView.transferAllDialog.filteredListMessage')
        : t('documentView.transferAllDialog.unFilteredListMessage')}
    </Modal>
  )
}

export default TransferAllDialog
